import React from 'react';
import {useIntl} from 'react-intl';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';


const FilterFromDate = ({
                          values,
                          handleSubmit,
                          setFieldValue,
                          placeholder = '',
                          containerStyles = 'col-lg',
                          customClearDate = null,
                          ...rest
                        }) => {

  const intl = useIntl();
  const searchByFromDate = intl.formatMessage({
    id: 'invoices-filter-fromDate',
    defaultMessage: 'From date',
  });
  const placeholderText = placeholder
    ? placeholder
    : searchByFromDate;

  return (
    <div className={containerStyles}>
      <DatePicker
        value={values.fromDate ? dayjs(values.fromDate) : null}
        className="form-control datepicker-form-control d-flex"
        placeholder={values.fromDate
          ? dayjs(values.fromDate).format('DD-MM-YYYY')
          : placeholderText
        }
        onChange={(date) => {
          if (date) {
            setFieldValue('fromDate', dayjs(date.$d).format('YYYY-MM-DD'));
          }
          handleSubmit();
        }}
        locale={locale}
        format={'DD-MM-YYYY'}
        clearIcon={
          <img
            src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
            alt="clear-filter"
            className="clear-datepicker-icon"
            onClick={() => {
              if (customClearDate) {
                customClearDate();
              } else {
                setFieldValue('fromDate', '');
              }
              handleSubmit();
            }}
          />
        }
        suffixIcon={false}
        showToday={false}
        disabledDate={(current) => {
          if (values.toDate) {
            return current && current > dayjs(values.toDate);
          }
        }}
        {...rest}
      />
    </div>
  );
};

export default FilterFromDate;
